import styled, { keyframes } from "styled-components";

const overlayIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const modalIn = keyframes`
  from { opacity: 0; transform: scale(0.93); }
  to   { opacity: 1; transform: scale(1); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0, 20, 50, 0.62);
  backdrop-filter: blur(6px);
  animation: ${overlayIn} 0.2s ease;

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 0.001s;
  }
`;

export const Modal = styled.div`
  width: 520px;
  max-width: 92vw;
  max-height: 92vh;
  overflow: auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 80px rgba(0, 30, 70, 0.3);
  animation: ${modalIn} 0.22s ease;

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 0.001s;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 28px 30px 26px;
  background: ${(props) => props.theme.brand.navy};
`;

/* Light tile so the hex mark (which has navy faces) stays visible on the
   navy header. */
export const HexBadge = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border-radius: 14px;
  background: #fff;
`;

export const HeaderText = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.h2`
  font-weight: 700;
  font-size: 21px;
  letter-spacing: 0.06em;
  color: #fff;
`;

export const CloseButton = styled.button`
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.12);
  transition: background 0.15s;

  &:hover {
    background: rgba(255, 255, 255, 0.24);
  }
`;

export const Body = styled.div`
  padding: 28px 30px 30px;
`;

interface NoteProps {
  $accent: string;
}

export const Note = styled.div<NoteProps>`
  padding: 14px 18px;
  border-radius: 8px;
  background: #f5f7fa;
  border-left: 4px solid ${(props) => props.$accent};

  p {
    font-size: 13px;
    line-height: 1.6;
    color: ${(props) => props.theme.brand.muted};
  }
`;
